import { useEffect } from 'react'

import { useAuth } from '@sportworld/js-sdk/src/context/authContext'

import { updateCreditWallets } from '@/actions'
import useStore from '@/store/useStore'

export const useCreditWalletsUpdate = () => {
  const { isRegisteredUser } = useAuth()
  const appConfigRefreshInterval = useStore(
    (state) => state.common.appConfig.refreshInterval,
  )
  const setUserCreditsWallets = useStore(
    (state) => state.common.setUserCreditsWallets,
  )
  useEffect(() => {
    if (!isRegisteredUser) {
      return
    }
    updateCreditWallets()
    const intervalId = setInterval(() => {
      updateCreditWallets()
    }, appConfigRefreshInterval * 1000)

    return () => {
      intervalId && clearInterval(intervalId)
      setUserCreditsWallets([])
    }
  }, [isRegisteredUser, appConfigRefreshInterval])

  return
}
